module.exports = __webpack_public_path__ + "assets/img/white_bg_first_team_info.png?c74780d0bcf5c8d8beea965dc7025c56";